module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hyRuA"))).then(() => parcelRequire('d0iPb'));